export default "__VITE_ASSET__BnyDTZgJ__"